import styled from 'styled-components';
import media from 'styled-media-query';
import { Heading } from 'components/shared';
import arrow from './arrow.svg';

const StepsContainer = styled.div`
  padding: 50px 0;
  background-color: var(--color-primary);

`;
const StyledImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background-color:var(--color-icon-background);
  border-radius: 100%;
  width: 4em;
  height: 4em;
  color: var(--color-primary);
  margin-bottom: 2em;
`
const StyledHeading = styled(Heading)`
  marging: 0;
  font-weight: 500;
  font-size: var(--font-size-l);
  text-align: center;
  color: #fff;
`;
const StyledSecondHeading = styled.p`
  marging: 0;
  font-weight: 400;
  font-size: var(--font-size-m);
  text-align: center;
  color: #fff;
`;
const AdditionalText = styled.p`
  marging: 0;
  font-weight: 400;
  font-size: var(--font-size-s);
  line-height: var(--line-height-list);
  text-align: center;
  color: #EDF3F5;
`;
const StyledNumber = styled.p`
  margin-bottom: 1em;
  font-weight: 400;
  font-size: var(--font-size-l);
  text-align: center;
  color: #fff;
  opacity: 0.5;
  `
const MainText = styled.p`
  marging: 0;
  font-weight: 600;
  font-size: var(--font-size-m);
  text-align: center;
  color: #fff;
  padding-bottom: 20px;
`;
const List = styled.ul`
  display: flex;
  flex-wrap: no-wrap;
  flex: 1 0 30%;
  gap: 20px;
  justify-content: space-between;
  width: 100%;
  padding: 52px 0;
  ${media.lessThan('medium')`
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap:20px;
  `};
`;

const Item = styled.li`
  position: relative;
  max-width: 350px;
  flex: 1 1 33%;
  background: #264f82;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: center;
  padding: 30px 20px 40px;
  box-sizing: border-box;
  ${media.lessThan('medium')`
    max-width: 275px;
    min-width: 275px;
  `};
    & + li {
    &:before {
      content: '';
      position: absolute;
      width: 40px;
      height: 40px;
      background: url(${arrow}) no-repeat 0 0;
      background-size: contain;
      top: 50%;
      left: -30px;
      transform: translateY(-50%);
      ${media.lessThan('medium')`
        top: -26px;
        left: 111px;
        transform: rotate(90deg);
      `};
    }
  }
`;

export { StepsContainer as StepsRepresentContainer, StyledNumber, StyledImage, MainText, StyledHeading as StepsRepresentHeading, List as StepsRepresentList, Item as StepsRepresentItem, AdditionalText, StyledSecondHeading };
